// Clears the entire cart (every product, free or not) once it is older than the max age.
// Shopify doesn't expose a cart creation date, so the time the cart first got an item is
// saved as a hidden cart attribute. It lives on the cart itself (server side), so guest
// and account carts share the same clock on every device.
// Adding/removing items does not reset it; only an empty cart does.

// Max age = hours + minutes. e.g. test: 0h 5min, live: 48h 0min.
const CART_MAX_AGE_HOURS = 48;
const CART_MAX_AGE_MINUTES = 0;

(function () {
  const ATTRIBUTE = '_cart_started_at'; // leading underscore hides it at checkout
  const MAX_AGE_MS = (CART_MAX_AGE_HOURS * 60 + CART_MAX_AGE_MINUTES) * 60 * 1000;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers, body: JSON.stringify(body || {}) });
  }

  // An empty string removes the attribute from the cart.
  function setStartedAt(value) {
    return post('cart/update.js', { attributes: { [ATTRIBUTE]: value } });
  }

  // allowClear is false for cart updates so we never wipe an item the visitor just added.
  function checkCart(allowClear) {
    return fetch(root + 'cart.js', { headers })
      .then((res) => res.json())
      .then((cart) => {
        const startedAt = Number(cart.attributes && cart.attributes[ATTRIBUTE]);

        if (!cart.item_count) {
          if (startedAt) return setStartedAt('');
          return;
        }

        if (!startedAt) return setStartedAt(String(Date.now()));

        if (!allowClear || Date.now() - startedAt < MAX_AGE_MS) return;

        // cart/clear.js empties the items but keeps attributes, so remove ours too.
        return post('cart/clear.js')
          .then(() => setStartedAt(''))
          .then(() => window.location.reload());
      })
      .catch((e) => console.error('cart-clear:', e));
  }

  checkCart(true);

  // Start the timer as soon as an item is added (cart drawer / AJAX add, no page load).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => checkCart(false));
  }
})();
